import { call, put } from 'redux-saga/effects';

import request from '../request';
import actions from '../../../actions';
import api from '../../../api';

export function* inviteOrganizationMember(organizationId, data) {
  try {
    yield call(request, api.inviteOrganizationMember, organizationId, data);
    // Success is handled by webhook or immediate update if needed
  } catch (error) {
    console.error('Invite failed:', error);
  }
}

export function* syncOrganizationFromClerk(organizationId) {
  try {
    yield call(request, api.syncOrganizationFromClerk, organizationId);
    // Success is handled by socket events broadcasting changes
  } catch (error) {
    console.error('Manual sync failed:', error);
  }
}

export function* removeOrganizationMember(organizationId, userId) {
  try {
    yield call(request, api.removeOrganizationMember, organizationId, userId);
    // Locally we don't remove it yet, we wait for handleOrganizationMembershipDelete or manual sync
  } catch (error) {
    console.error('Removal failed:', error);
  }
}

export function* handleOrganizationMembershipDelete(organizationId, userId) {
  // This would be called when a socket event is received
  yield put(actions.deleteOrganizationMembership(organizationId, userId));
}

export default {
  inviteOrganizationMember,
  syncOrganizationFromClerk,
  removeOrganizationMember,
  handleOrganizationMembershipDelete,
};
